import { useState } from 'react';

const CheckInModal = ({ onClose, onSubmit, loading }) => {
  const [formData, setFormData] = useState({
    feeling: '',
    notes: '',
    health_concerns: '',
    latitude: null,
    longitude: null,
    location_address: ''
  });
  const [locationLoading, setLocationLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const getLocation = () => {
    setLocationLoading(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setFormData(prev => ({
            ...prev,
            latitude,
            longitude,
            location_address: `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`
          }));
          setLocationLoading(false);
        },
        (error) => {
          console.error('Error getting location:', error);
          setLocationLoading(false);
        }
      );
    } else {
      setLocationLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="modal-overlay" data-testid="checkin-modal">
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">Daily Check-In</h2>
          <button className="modal-close" onClick={onClose} data-testid="close-modal">
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="checkin-form">
          <div className="form-group">
            <label htmlFor="feeling">How are you feeling today?</label>
            <select
              id="feeling"
              name="feeling"
              value={formData.feeling}
              onChange={handleChange}
              data-testid="feeling-select"
            >
              <option value="">Select...</option>
              <option value="Great">Great 😊</option>
              <option value="Good">Good 👍</option>
              <option value="Okay">Okay 😐</option>
              <option value="Tired">Tired 😴</option>
              <option value="Not Well">Not Well 😟</option>
              <option value="Stressed">Stressed 😰</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="notes">Daily Notes / Observations</label>
            <textarea
              id="notes"
              name="notes"
              rows="3"
              value={formData.notes}
              onChange={handleChange}
              placeholder="How is your client doing? Any observations or updates..."
              data-testid="notes-textarea"
            />
          </div>

          <div className="form-group">
            <label htmlFor="health_concerns">Your Health Concerns (if any)</label>
            <textarea
              id="health_concerns"
              name="health_concerns"
              rows="2"
              value={formData.health_concerns}
              onChange={handleChange}
              placeholder="Any symptoms, issues, or concerns about your own health..."
              data-testid="health-concerns-textarea"
            />
          </div>

          <div className="form-group">
            <label>Location (Optional)</label>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
              <button
                type="button"
                className="location-button"
                onClick={getLocation}
                disabled={locationLoading}
                data-testid="get-location-button"
              >
                {locationLoading ? 'Getting Location...' : formData.latitude ? '📍 Location Captured' : '📍 Capture Location'}
              </button>
              {formData.location_address && (
                <span style={{ fontSize: '0.9rem', color: '#6b8899' }}>
                  {formData.location_address}
                </span>
              )}
            </div>
            <small style={{ color: '#6b8899', fontSize: '0.875rem', marginTop: '0.5rem', display: 'block' }}>
              Helps emergency contacts know where you are
            </small>
          </div>

          <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
            <button
              type="submit"
              className="submit-button"
              disabled={loading}
              data-testid="submit-checkin"
            >
              {loading ? 'Checking in...' : "I'm OK - Check In"}
            </button>
            <button
              type="button"
              className="submit-button"
              onClick={onClose}
              style={{ background: '#6c757d' }}
              data-testid="cancel-checkin"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CheckInModal;
